import React, { useEffect, useState } from "react";
import { FxmsData } from "../datas/FxData";
import { FxLabel } from "./FxLabel";

/**
 * Select박스 별도 생성
 *
 * @param {attr, change, fxInObj} props
 * attr : 어떤 내용으로 채울지 나타낸다.
 * change : item이 변경되면 호출하는 함수 ( id, value을 넘김 )
 * fxInObj : 입력값
 * @returns
 */

export const FxSelect = props => {

  const { attr, onChangeValue, fxInObj, inputType } = props;
  const [datas, setDatas] = React.useState(makeSelectPara(attr.attrValType, attr.attrValObj, attr.attrValList));

  // SELECT박스의 조건이 변경될 경우 REFRESH한다.
  if (datas.refIDs) {
    attr.refreshItems = function (id, value) {
      if (checkRefresh(datas, id, value)) {
        setDatas({ type: datas.type, para: datas.para, optionText: datas.optionText });
      }
    }
  }

  // Select 박스에 채울 값 가져오기
  useEffect(() => {

    setDatas(makeSelectPara(attr.attrValType, attr.attrValObj, attr.attrValList));

  }, [attr]);


  return (
    <>
      <FxLabel attr={attr} inputType={inputType} />
      <FxSelectBase className={"FxSelect" + (inputType === undefined ? "" : inputType)}
        name={attr.attrName}
        onChangeValue={onChangeValue}
        disabled={attr.readOnlyYn === 'Y'}
        datas={datas}
        width={attr.uiWidth}
        defaultValue={fxInObj[attr.attrName]}
      />
    </>
  );
}

/**
 *
 * @param {*} props
 * @returns
 */
export const FxSelect2 = props => {
  const { attrClass, defaultValue } = props;
  const attr = attrClass.getAttr();
  const [datas, setDatas] = React.useState(makeSelectPara(attr.attrValType, attr.attrValObj, attr.attrValList));

  // Select 박스에 채울 값 가져오기
  useEffect(() => {

    setDatas(makeSelectPara(attr.attrValType, attr.attrValObj, attr.attrValList));

  }, [attr]);


  // SELECT박스의 조건이 변경될 경우 REFRESH한다.
  if (datas.refIDs) {
    attr.refreshItems = function (id, value) {
      if (checkRefresh(datas, id, value)) {
        setDatas({ type: datas.type, para: datas.para, optionText: datas.optionText });
      }
    }
  }


  return (
    <>
      <FxSelectBase className="FxSelect"
        name={attrClass.getId()}
        onChangeValue={props.para.onChange}
        disabled={attrClass.isDisable()}
        datas={datas}
        width={attr.uiWidth}
        defaultValue={defaultValue}
      />
    </>
  );

}


/**
 * 기본 Select 박스
 *
 * @param {function(id, value)} onChangeValue Select박스가 선택되었을 때 호출하는 함수 function(id, value)
 * @param {*} defaultValue 기본값
 * @param {string} name ID 및 이름
 * @param {string} className css명
 * @param {boolean} disabled 비활성화여부
 * @param {number} width 넓이
 * @param {object} datas 목록을 가져올 조건
 * @returns
 */
export const FxSelectBase = props => {

  const { onChangeValue, defaultValue, name, className, disabled, width, datas, selectedData, defOptions } = props;
  const [options, setOptions] = React.useState([]);
  const [selectedValue, setSelectedValue] = React.useState("");
  const sx = {};

  // 길이가 정의되어 있으면 지정
  if (width) {
    sx.minWidth = width;
    sx.width = width;
  }

  useEffect(() => {
    // 조회 조건에 의한 Select 박스에 채울 값 가져오기
    if (datas && datas.type) {
      loadOptions(datas.type, datas.para, datas.optionText);
    }
  }, [datas]);

  useEffect(() => {
    // 강제로 옵션 채우기
    if (defOptions && defOptions.length > 0 ) {
      initOption(defOptions);
    }
  }, [defOptions]);


  async function loadOptions(type, para, optionText) {

    // 조건에 맞는 목록을 가져온다.
    const list = await FxmsData.getSelectItemRt(type, para);

    // 첫 OPTION에 메모 사항이 있으면 넣어준다.
    if (optionText) {
      list.unshift({ key: "", text: optionText });
    }

    // Select박스를 채울 목록을 설정한다.
    initOption(list);
  }

  function initOption(list) {
     // Select박스를 채울 목록을 설정한다.
     setOptions(list);

     // 최초 선택값을 지정한다.
     if (list.length > 0) {
       let val = defaultValue ? defaultValue : selectedData ? selectedData[name] : list[0].key;
       setSelectedValue(val);
       onChangeValue(name, val, getObj(val));
     }
  }


  function getObj(value) {
    if (options) {
      for (let obj of options) {
        if (obj.key === value) {
          return obj.fxObject;
        }
      }
    }
    return null;
  }

  return (
    <>
      <select
        className={className ? className : "FxSelect"}
        id={name}
        name={name}
        onChange={function (event) {
          onChangeValue(event.target.name, event.target.value, getObj(event.target.value));
          setSelectedValue(event.target.value);
        }}
        value={selectedValue}
        style={sx}
        disabled={disabled}
      >
        {options.map((x, index) => {
          return <option key={x.key} value={x.key}>{x.text}</option>
        })}
      </select>
    </>
  );

}

/**
 * SELECT박스를 채울 조건을 생성한다.
 * @param {*} attrValType 속성값의 종류 예) code
 * @param {*} attrValObj  속성값의 객체 예) cdClass='INLO_CL_CD'
 * @param {*} attrValList JSON형식의 속성정의
 * @returns
 */
export function makeSelectPara(attrValType, attrValObj, attrValList) {

  let retObj = {};

  // 입력된 조건을 확인한다.
  if (attrValType) {
    retObj.type = attrValType;  // code
    retObj.para = attrValObj;  // cdClass='TEST'
  } else {
    retObj.para = JSON.parse(attrValList);
    retObj.type = retObj.para.type;
    if (retObj.para.all) {
      retObj.optionText = retObj.para.all;
    }
  }

  if (retObj.para.refreshIds) {
    retObj.refIDs = retObj.para.refreshIds.split(',');
    console.log("retObj.refIDs : " + retObj.refIDs);
  }

  // 백엔드 호출할 때 파라메터로 넘어가는 것을 막기 위해 여기서 삭제한다.
  delete retObj.para.refreshIds;
  delete retObj.para.type;
  delete retObj.para.all;

  return retObj;
}

/**
 * Select박스를 refresh할 것인지 알아본다.
 * @param {*} datas 목록조건 데이터
 * @param {*} id 변경된 속성의 ID
 * @param {*} value 변경된 속송의 값
 * @returns
 */
function checkRefresh(datas, id, value) {
  let para = datas.para;
  let doRefresh = false;
  for (const refId of datas.refIDs) {
    if (refId === id) {
      if (value) {
        para[id] = value;
      } else {
        delete para[id];
      }
      doRefresh = true;
    }
  }

  return doRefresh;
}

/**
 * 0 ~ 23 시간을 나타내는 콤보박스
 *
 * @param {function(id, value)} onChangeValue Select박스가 선택되었을 때 호출하는 함수 function(id, value)
 * @param {*} defaultValue 기본값
 * @param {string} name ID 및 이름
 * @param {boolean} disabled 비활성화여부
 * @param {number} width 넓이
 * @param {string} optionText 옵션 선택 문구
 * @returns
 */
export const FxTimeSelect = (props) => {
  const { onChangeValue, defaultValue, width, name, optionText, disabled } = props;
  const [defOptions, setDefOptions] = React.useState({});

  useEffect(() => {
    let options = [];
    if ( optionText ) {
      options.push({key : "", text : optionText});
    }
    for (let i = 0; i < 24; i++) {
      options.push({key : i, text : i});
    }
    setDefOptions(options);
  }, []);

  return (
    <>
      <FxSelectBase
        name={name}
        onChangeValue={onChangeValue}
        defOptions={defOptions}
        width={width}
        disabled={disabled}
        defaultValue={defaultValue}
        selectedData={props.selectedData}
      />
    </>
  );
};